import React, { Component } from 'react';
import SortedResults from './SortedResults';
import './ActionBar.css';
import ActionDialog from './ActionDialog'

class ActionBar extends Component {
  constructor() {
    super();
    this.state = {
      dialogView: null
    }
  }

  doSort() {
    this.setState({
      dialogView: 'showSorted'
    })
  }

  dismissDialog() {
    this.setState({
      dialogView: null
    })
  }

  clearToggled() {
    if (this.props.onClearToggle) {
      this.props.onClearToggle();
    }
  }

  render() {
    var dialogView;

    switch (this.state.dialogView) {
      case 'showSorted':
        dialogView = (<ActionDialog headerTxt="SORTED">
                        <SortedResults results={this.props.items} />
                        <button onClick={this.dismissDialog.bind(this)}>Ok</button>
                      </ActionDialog>);
        break;

      default:
        dialogView = null
    }

    return (
      <div className='actionBar'>
        <span className="actionMessage">{Object.keys(this.props.items).length} Selected</span>
        <button className="btnSmall" onClick={this.doSort.bind(this)}>Sort</button>
        <span className="btnSmall_seperator" />
        <button className="btnSmall" onClick={this.clearToggled.bind(this)}>Clear</button>
        {dialogView}
      </div>
    )
  }
}

export default ActionBar


// WEBPACK FOOTER //
// ./src/RollResults/ActionBar/ActionBar.js